import React, { useState } from 'react';
import { connect } from 'react-redux';

import LockIcon from '~/components/Shared/Icons/LockIcon';
import ErrorIcon from '~/components/Workflow/shared/ErrorIcon';
import { injectIntl } from 'react-intl';
import { getErrors } from '~/reducers/workflow';
import FlexLayout from '~/ui/components/FlexLayout/FlexLayout';
import PageLayout from '~/ui/components/PageLayout/PageLayout';

import Conditions from './Conditions/Conditions';
import Fields from './Fields/Fields';

function Sidebar({
  // connected
  disabled,
  errors,
  shouldValidate,
  intl,
}) {
  const [selectedTab, setSelectedTab] = useState('fields');

  const tabsData = {
    fields: {
      component: <Fields />,
      iconRight: disabled ? (
        <LockIcon />
      ) : (
        <ErrorIcon
          errors={errors.fields}
          shouldRender={shouldValidate}
          variant="yellow"
        />
      ),
      label: intl.formatMessage({
        id: 'Sidebar.fieldsLabel',
        defaultMessage: 'Fields',
        description: 'Label for the fields tab',
      }),
      value: 'fields',
    },
    conditions: {
      component: <Conditions />,
      iconRight: disabled ? (
        <LockIcon />
      ) : (
        <ErrorIcon
          errors={errors.conditions}
          shouldRender={shouldValidate}
          variant="yellow"
        />
      ),
      label: intl.formatMessage({
        id: 'Sidebar.conditionsLabel',
        defaultMessage: 'Conditions',
        description: 'Label for the conditions tab',
      }),
      value: 'conditions',
    },
  };

  return (
    <FlexLayout
      flexDirection="column"
      flex="1 1 auto"
      pb={5}
      space={3}
      sx={{ overflow: 'hidden' }}
    >
      <PageLayout.SidebarTabs
        selectedTab={selectedTab}
        tabs={Object.values(tabsData)}
        onSelectTab={setSelectedTab}
      />
      {tabsData[selectedTab].component}
    </FlexLayout>
  );
}

function mapStateToProps({ builder, workflow, client }, { intl }) {
  return {
    disabled: !builder.shouldEnableAllComponents,
    errors: getErrors(workflow, builder, client, undefined, intl),
    shouldValidate: builder.shouldValidate,
  };
}

export default injectIntl(connect(mapStateToProps)(Sidebar));
